import React, {useState} from 'react';
import {Grid, Button, ButtonGroup} from '@material-ui/core';
import {
    Visibility as VisibilityIcon,
    Save as SaveIcon,
} from '@material-ui/icons';
import {Link, Redirect, withRouter} from 'react-router-dom';
import {isEmpty} from 'lodash/lang';
import {PrimaryButton} from '../common/StyledButtons';
import {connect} from 'react-redux';
import {createForm} from 'rc-form';


export default function (props) {
    let {quizId = {}, saveQuiz, preview, previewQuiz} = props;
    return (
        <>
            {/*{redirect && <Redirect push to={`/quizzes/${quizId}/preview`}/>}*/}
            <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="center"
            >
                <ButtonGroup color="primary">
                    <PrimaryButton onClick={previewQuiz}
                        disabled={isEmpty(quizId) || !preview} className="quizscape-action-btn">
                        <VisibilityIcon/> Preview
                    </PrimaryButton>
                    <PrimaryButton onClick={saveQuiz} className="quizscape-action-btn">
                        <SaveIcon/>
                        Save
                    </PrimaryButton>
                </ButtonGroup>
            </Grid>
        </>
    );
}